import { render } from "./AreaGrouping.vue?vue&type=template&id=4d5439ae&scoped=true"
import script from "./AreaGrouping.vue?vue&type=script&lang=js"
export * from "./AreaGrouping.vue?vue&type=script&lang=js"

import "./AreaGrouping.vue?vue&type=style&index=0&id=4d5439ae&scoped=true&lang=css"
import "./AreaGrouping.vue?vue&type=style&index=1&id=4d5439ae&lang=scss"

import exportComponent from "C:\\ProgramData\\Jenkins\\.jenkins\\workspace\\四个火体育_web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d5439ae"]])

export default __exports__